import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "./IncreaseDealSizeCard.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchIncreaseDealSizeCardRequest } from "../../../../../store/features/actions/opportunities/increaseDealSizeCardActions";
import * as FeatherIcon from "react-feather";
import Button from 'react-bootstrap/Button';
import iq_api_v2 from "../../../../../services/iqApiV2";
import qs from 'qs';
import { listDealsRequest } from "../../../../../store/features/actions/opportunities/increaseDealSizeActions/listDealsActions";
import { useUser } from "../../../../../context/UserContext";
import { useBanner } from "../../../../../context/BannerContext";

export default function IncreaseDealSizeCard({opportunityId, deal_id, setShowMoreModal }) {
 const {user}= useUser()
  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const [deal_opportunity, setDealResult] = useState(null);
  const [contacts, setContacts] = useState(deal_opportunity?.contacts || []);
  const [products, setProducts] = useState(deal_opportunity?.products || []);
  const [checkedState, setCheckedState] = useState([])
  const [removedOpportunities, setRemovedOpportunities] = useState([])
  const [isEditingDealName, setIsEditingDealName] = useState(false);
  const [editableDealName, setEditableDealName] = useState("");

  const { clientName, accountName } = useParams();
  const { increaseDealSizeCardData, increaseDealSizeCardLoading, error } = useSelector(
    (state) => state?.increaseDealSizeCardReducer
  );

  useEffect(() => {
    if (deal_id) {
      dispatch(
        fetchIncreaseDealSizeCardRequest({
          deal_id
        })
      );
    }
  }, [deal_id]);

  useEffect(() => {
    if (error) {
      setStatus("Error loading data");
    }else{
      setResult(increaseDealSizeCardData?.result || []);
      
      const opportunities = increaseDealSizeCardData?.result?.combined_opportunities || [];
      const deal_opportunity = Array.isArray(opportunities) && opportunities.length > 0
        ? opportunities[opportunities.length - 1]
        : [];

      setDealResult(deal_opportunity || []);
    }
  }, [increaseDealSizeCardData, error]);

  useEffect(() => {
    // console.log("increaseDealSizeCardLoading : ", increaseDealSizeCardLoading, increaseDealSizeCardData)
  }, [increaseDealSizeCardLoading])

  useEffect(() => {

    deal_opportunity?.contacts?.forEach(d => {
      d.checked = true;
    });
    setContacts(deal_opportunity?.contacts || [])

    setProducts(deal_opportunity?.products || [])

    setCheckedState(new Array(deal_opportunity?.products?.length || 0).fill(true))

  }, [deal_opportunity])

  const handleOpportunityCheckboxChange = (opportunity_id, is_checked) => {
      if(is_checked === false){
        setRemovedOpportunities([opportunity_id])
      }else{
        setRemovedOpportunities([])
      }
  }

  const handleContactCheckboxChange = (index) => {
    const updatedContacts = [...contacts];
    updatedContacts[index].checked = !updatedContacts[index]?.checked;
    setContacts(updatedContacts);
  };

  const handleProductCheckboxChange = (index) => {
    const updatedCheckedState = [...checkedState];
    updatedCheckedState[index] = !updatedCheckedState[index];
    setCheckedState(updatedCheckedState);
  };
  const showBanner = useBanner()
  const updateDeal = async(update_data) => {
    try {
      if(update_data){
        const queryString = qs.stringify(update_data);
        const upload_response = await iq_api_v2.post("/deals/update_deal?", queryString, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json', // Matches your curl
          },
        });

        showBanner({ message: 'Deal Updated',title:"Alert", type: 'success', duration: 2000 })
        return upload_response; // You need to return this if you want to use it later
      }

    } catch (error) {
      console.error("Error updating deal:", error);
      throw error; // Optional: rethrow for handling higher up
    }
  }

  const handleUpdateData = async() => {

    const uncheckedContactIds = contacts.filter((_, index) => !contacts[index].checked).map(contact => contact._id);
    const uncheckedProducts = products.filter((_, index) => !checkedState[index]);
    const update_data = {
      'deal_id': deal_id,
      'opportunity_name': editableDealName?.trim() || result?.opportunity_name,
      'opportunity_id_to_remove': removedOpportunities.join(","),
      'contact_ids_to_remove': uncheckedContactIds.join(","),
      'products_to_remove': uncheckedProducts.join(",")
    }

    const response = await updateDeal(update_data);  
    if (response) {
      setTimeout(() => {
        dispatch(listDealsRequest({ userId: user?.id,accountName,clientName }));
      }, 1000);
    }

    setShowMoreModal(false);
  }

  useEffect(() => {
    if (result?.opportunity_name) {
      console.log("result : ", result)
      setEditableDealName(result?.opportunity_name || "");
    }
  }, [result?.opportunity_name]);

  const handleSetIsEditingDealName = () => {
    if(editableDealName.trim() == "") {
      showBanner({ message: 'Deal name cannot be empty', title: 'Validation', type: 'error' });
      return 
    }
    setIsEditingDealName(false)
  }

  return (
    <div>
   
   <div className="before_after_sidecard_wrapper">
   {/* <div className="back_top_block">
        <div className="back_btn cursorP" onClick={()=> setShowMoreModal(false)}>
            <FeatherIcon.ChevronLeft className="fa" />Back
        </div>
      </div> */}

      {increaseDealSizeCardLoading == true ? (
        
        <div className="d-flex justify-content-center mb-3">
          <div className="before_top_main_block pr-0 placeholder-glow">
            <div className="before_main_block">
              <h5 className="before_main_head ml-2 "> <span className="placeholder w-25">  </span> </h5>
            </div>
            <div className="before_block">
              <div className="before_sbblock ">
                <div className="before_subblock_head border-rad-before placeholder bg-dark w-100">
                  <h5 className="before_head "> <span className="col-md-2 "> &nbsp;  </span>  </h5>
                </div>
                <div className="before_tags card-text"> 
                  <a className="before_tag_close mb-1 placeholder w-100 bg-dark mb-3">  </a>
                  <a className="before_tag_close mb-1 placeholder w-100 bg-dark mb-3">  </a>
                </div>
              </div>

              <div className="before_sbblock">
                <div className="before_subblock_head placeholder bg-dark  w-100 ">
                  <h5 className="before_head w-100 "> &nbsp; </h5>
                </div>
                <div className="before_list mt-2 " >
                  <p className="before_list_head placeholder w-75"> &nbsp; </p>
                  <ul className="before_list_ul">
                  {[...Array(5)].map((_, i) => (
                  <li className="before_list_li placeholder placeholder-xs w-100" > </li>
                  ))}   
                  </ul>
                </div>
              </div>

              <div className="before_sbblock">
                <div className="before_subblock_head placeholder bg-dark  w-100 ">
                  <h5 className="before_head w-100 "> &nbsp; </h5>
                </div>
                <div className="before_list mt-2 " >
                  <p className="before_list_head placeholder w-75"> &nbsp; </p>
                  <ul className="before_list_ul">
                  {[...Array(5)].map((_, i) => (
                  <li className="before_list_li placeholder placeholder-xs w-100" > </li>
                  ))}   
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="middle_arrow_main_block p-0">
            <div className="middle_arrow_block ">
            <FeatherIcon.ChevronsRight className="fa light-grey" />
            </div>
          </div>
          
          <div className="before_top_main_block pr-0 placeholder-glow">
            <div className="before_main_block">
              <h5 className="before_main_head ml-2 "> <span className="placeholder w-25">  </span> </h5>
            </div>
            <div className="before_block">
              <div className="before_sbblock ">
                <div className="before_subblock_head border-rad-before placeholder bg-dark w-100">
                  <h5 className="before_head "> <span className="col-md-2 "> &nbsp;  </span>  </h5>
                </div>
                <div className="before_tags card-text"> 
                  <a className="before_tag_close mb-1 placeholder w-100 bg-dark mb-3">  </a>
                  <a className="before_tag_close mb-1 placeholder w-100 bg-dark mb-3">  </a>
                </div>
              </div>

              <div className="before_sbblock">
                <div className="before_subblock_head placeholder bg-dark  w-100 ">
                  <h5 className="before_head w-100 "> &nbsp; </h5>
                </div>
                <div className="before_list mt-2 " >
                  <p className="before_list_head placeholder w-75"> &nbsp; </p>
                  <ul className="before_list_ul">
                  {[...Array(5)].map((_, i) => (
                  <li className="before_list_li placeholder placeholder-xs w-100" > </li>
                  ))}   
                  </ul>
                </div>
              </div>

              <div className="before_sbblock">
                <div className="before_subblock_head placeholder bg-dark  w-100 ">
                  <h5 className="before_head w-100 "> &nbsp; </h5>
                </div>
                <div className="before_list mt-2 " >
                  <p className="before_list_head placeholder w-75"> &nbsp; </p>
                  <ul className="before_list_ul">
                  {[...Array(5)].map((_, i) => (
                  <li className="before_list_li placeholder placeholder-xs w-100" > </li>
                  ))}   
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
        
      ) : (

      <div className="d-flex justify-content-center mb-3 mt-2">
        <div className="before_top_main_block pr-0">
          <div className="before_main_block">
          <h5 className="before_main_head ml-2">Before</h5>
          </div>
          <div className="before_block">
            <div className="before_sbblock">
              <div className="before_subblock_head border-rad-before">
                <h5 className="before_head">Current Opportunities</h5>
              </div>
              <div className="before_tags">
              {result?.before_opportunities?.map((opportunity, index) => {
                return (
                  <a key={opportunity?.id || index} className="before_tag_close mb-1">
                    {opportunity?.opportunity_name} {' '}
                    <FeatherIcon.X className="close_tag" />
                  </a>
                );
              })}
              </div>
              
            </div>
            <div className="before_sbblock">
              <div className="before_subblock_head">
                <h5 className="before_head">Current Contacts</h5>
              </div>

              {result?.before_opportunities?.map((opportunity, index) => {
                return (
                  <div className="before_list mt-2" key={index}>
                    <p className="before_list_head">{opportunity?.opportunity_name}</p>
                    <ul className="before_list_ul">
                    {opportunity?.contacts?.map((contact, index) => {
                      return (
                        <li className="before_list_li" key={index}><span className="name"> {contact?.name} </span> <span className="designation_before">- {contact?.title} </span></li>
                      )
                    })}
                    </ul>
                  </div>
                );
              })}
            </div>
            <div className="before_sbblock">
              <div className="before_subblock_head">
                <h5 className="before_head">Current Products</h5>
              </div>
              {result?.before_opportunities?.products?.length > 0 ? (
                
                result?.before_opportunities?.map((opportunity, index) => {
                return (
                  <div className="before_list mt-2" key={index}>
                    <p className="before_list_head">{opportunity?.opportunity_name}</p>
                    <ul className="before_list_ul">
                    {opportunity?.products?.map((contact, index) => {
                      return (
                        <li className="before_list_li" key={index}><span className="name"> {contact?.name} </span> <span className="designation_before">- {contact?.title}, {contact?.geography} </span></li>
                      )
                    })}
                    </ul>
                  </div>
                );
              }))  : (
                 <div className="row">
                  <div className="col-md-12 p-4 font12">
                    No product data available
                  </div>
                 </div>
                )
              }
            </div>
          </div>
        </div>
        <div className="middle_arrow_main_block p-0">
          <div className="middle_arrow_block">
          <FeatherIcon.ChevronsRight className="fa" />
          </div>
        </div>
        <div className="after_top_main_block pl-0">
          <div className="after_main_block">
          <h5 className="after_main_head ml-2">After</h5>
          {/* <Button className="regenerate_btn">Regenerate <FeatherIcon.RotateCcw className="rotate_icon" /></Button> */}


          </div>
          <div className="after_block">
            <div className="after_sbblock">
              <div className="after_subblock_head border-rad-before">
                <h5 className="after_head">New Increased Deal </h5>
              </div>
              <div className="after_tags">
                {/* <div className="deal_name_edit"> 
                Deal Name: {result?.opportunity_name}
                </div>
                <div className="edit_tag_block">
                <FeatherIcon.Edit2 className="edit_tag"/>
                </div> */}

                <div className="deal_name_edit_block d-flex align-items-center">
                  {isEditingDealName ? (
                    <>
                      <input
                        className="form-control"
                        type="text"
                        value={editableDealName || ''}
                        onChange={(e) => setEditableDealName(e.target.value)}
                        style={{ maxWidth: "250px", marginRight: "10px", fontSize: '12px' }}
                      />
                      <FeatherIcon.Check
                        className="edit_tag text-success cursorP"
                        onClick={() => handleSetIsEditingDealName(false)}
                      />
                      <FeatherIcon.X
                        className="edit_tag text-danger cursorP ml-2"
                        onClick={() => {
                          setEditableDealName(result.opportunity_name); // reset to original
                          setIsEditingDealName(false);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div className="deal_name_edit">
                        Deal Name: {editableDealName}
                      </div>
                      <div className="edit_tag_block cursorP" onClick={() => setIsEditingDealName(true)}>
                        <FeatherIcon.Edit2 className="edit_tag" />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="after_list mt-2">
                <p className="after_list_head">Current Opportunities plus</p>
                <ul className="after_list_ul">
                <li className="after_list_li">
                  <div className="d-flex">
                  <input 
                    type="checkbox" class="form-check-input after_checkbox" 
                    checked={removedOpportunities.indexOf(deal_opportunity?._id)}
                    onChange={(e) => handleOpportunityCheckboxChange(deal_opportunity?._id, e.target.checked)} 
                  />
                  <span className="name">{deal_opportunity?.opportunity_name}</span>
                  </div>

                   <span className="designation_before ml-4">&nbsp; {deal_opportunity?.signal}</span></li>
                {/* <li className="after_list_li"><input type="checkbox" class="form-check-input after_checkbox"/><span className="name">Pilotless Jets</span> <span className="designation_before">- Nudges</span></li>
                <li className="after_list_li"><input type="checkbox" class="form-check-input after_checkbox"/><span className="name">Pilotless Jets</span> <span className="designation_before">- Nudges</span></li> */}
                </ul>
              </div>
            </div>
            {deal_opportunity?.contacts?.length > 0 && 
            <div className="after_sbblock">
              <div className="after_subblock_head">
                <h5 className="after_head">New Contacts</h5>
              </div>

              <div className="after_list mt-2">
                <p className="after_list_head">Current Contacts plus</p>
                  <ul className="after_list_ul">
                  {deal_opportunity?.contacts?.map((contact, index) => {
                    return (
                      <li className="after_list_li" key={index}>
                        <div className="d-flex">
                        <input
                          type="checkbox"
                          className="form-check-input after_checkbox"
                          checked={contact?.checked || false}
                          onChange={() => handleContactCheckboxChange(index)}
                        />
                        <span className="name">{contact?.name}</span>
                        </div>
                        <span className="designation_before ml-4">
                          &nbsp;{contact?.title}
                        </span>
                      </li>
                    )
                  })}
                  </ul>
              </div>
            </div>
            }
            <div className="after_sbblock">
              <div className="after_subblock_head">
                <h5 className="after_head">New Products</h5>
              </div>
              <div className="after_list mt-2">
                <p className="after_list_head">Current Products plus</p>
                  <ul className="after_list_ul">
                  {deal_opportunity?.products?.map((product, index) => {
                    return (
                      <li className="after_list_li" key={index}>
                        <input type="checkbox" checked={checkedState[index]} class="form-check-input after_checkbox"
                        onChange={() => handleProductCheckboxChange(index)}
                        />  <span className="name"> {product} </span> </li>
                    )
                  })}
                  </ul>
              </div>
            </div>
          </div>
        </div>
    
      </div>
      )}

      <div className="cancel_bottom_block">
        <div className="cancel_btn_block">
        <Button className="cancel_btn" onClick={()=> setShowMoreModal(false)} >Cancel </Button>
        <Button className="update_btn" onClick={()=> handleUpdateData()} ><FeatherIcon.RotateCcw className="update_icon" /> Update new deal with selected items </Button>
        </div>
      </div>
   </div>
   </div>
  );
}
